import React from 'react';

const Clock = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M4.53125 16.9688C5.90625 18.3438 7.5625 19.0312 9.5 19.0312C11.4375 19.0312 13.0781 18.3438 14.4219 16.9688C15.7969 15.5938 16.4844 13.9375 16.4844 12C16.4844 10.0625 15.7969 8.42188 14.4219 7.07812C13.0781 5.70312 11.4375 5.01562 9.5 5.01562C7.5625 5.01562 5.90625 5.70312 4.53125 7.07812C3.1875 8.42188 2.51562 10.0625 2.51562 12C2.51562 13.9375 3.1875 15.5938 4.53125 16.9688ZM16.5312 6.42188C17.8438 8.07812 18.5 9.9375 18.5 12C18.5 14.4688 17.625 16.5938 15.875 18.375C14.125 20.125 12 21 9.5 21C7 21 4.875 20.125 3.125 18.375C1.375 16.5938 0.5 14.4688 0.5 12C0.5 9.53125 1.375 7.42188 3.125 5.67188C4.875 3.89062 7 3 9.5 3C11.5312 3 13.4062 3.67188 15.125 5.01562L15.8295 4.28766C16.2265 3.87739 16.8639 3.82377 17.2671 4.22801C17.6624 4.62443 17.6433 5.27274 17.254 5.67508L16.5312 6.42188ZM9.5 13.0312C8.95634 13.0312 8.51562 12.5905 8.51562 12.0469V8.01562C8.51562 7.47197 8.95634 7.03125 9.5 7.03125C10.0437 7.03125 10.4844 7.47197 10.4844 8.01562V12.0469C10.4844 12.5905 10.0437 13.0312 9.5 13.0312ZM11.4922 0C12.0488 0 12.5 0.451213 12.5 1.00781C12.5 1.56441 12.0488 2.01562 11.4922 2.01562H7.50781C6.95121 2.01562 6.5 1.56441 6.5 1.00781C6.5 0.451213 6.95121 0 7.50781 0H11.4922Z"
      fill="#00244D"
    />
  </svg>
);

export default Clock;
